"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createReactContext = _interopRequireDefault(require("@ant-design/create-react-context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormContext = (0, _createReactContext["default"])({
  labelAlign: 'right',
  vertical: false
});
var _default = FormContext;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/form/context.js
// module id = 313
// module chunks = 0